export default "__VITE_ASSET__BQ2nZTVN__"